// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const skiVillageRoom: Room = {
  name: 'Ski Village',
  background: '/media/club-penguin/ski village.webp',
  spawn: { x: 341, y: 338 },

  colliders: [
    ...STANDARD_BOUNDARIES,
    { x: 20, y: 20, w: 178, h: 409 },
    { x: 203, y: 23, w: 661, h: 241 },
    { x: 834, y: 34, w: 103, h: 325 },
    { x: 709, y: 475, w: 232, h: 45 },
  ],

  hotspots: [
    {
      id: 'ski-village-to-beach',
      action: 'goto',
      target: 'beach',
      spawn: { x: 548, y: 186 },
      x: 24,
      y: 433,
      w: 174,
      h: 85,
    },
    {
      id: 'ski-village-to-sky-hill',
      action: 'goto',
      target: 'ski-hill',
      spawn: { x: 701, y: 254 },
      x: 199,
      y: 265,
      w: 93,
      h: 89,
    },
    {
      id: 'ski-village-to-stadium',
      action: 'goto',
      target: 'stadium',
      spawn: { x: 207, y: 200 },
      x: 857,
      y: 359,
      w: 79,
      h: 99,
    },
  ],
};
